import { useNavigate } from 'react-router-dom';
import type { Product } from '@/data/catalogue';

export function ProductCard({ product }: { product: Product }) {
  const navigate = useNavigate();
  return (
    <div className="card" onClick={() => navigate(`/product/${product.code}`)}>
      <div className="card-img">
        <img src={product.image} alt={product.name} loading="lazy" />
      </div>
      <div className="card-name">{product.name}</div>
    </div>
  );
}
